import styles from './spot-rewards-empty-card.module.scss';
import Card from '../../general/card/card';

export type SpotRewardEmptyCardProps = {
  icon: string;
  title: string;
  subtitle: string;
};

const SpotRewardsEmptyCard = ({
  icon,
  title,
  subtitle,
}: SpotRewardEmptyCardProps) => (
  <Card classString='card--hero-card' className={styles.cardStyle}>
    <img src={icon} className={styles.icon} />

    <p className={styles.title}>{title}</p>

    <p className={styles.subtitle}>{subtitle}</p>
  </Card>
);

export default SpotRewardsEmptyCard;
